import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CountryCode } from 'src/app/services/translation/country-code';
import { Language } from 'src/app/services/translation/language';
import { TranslationService } from 'src/app/services/translation/translation.service';
import { Environment } from 'src/environments/environment';

@Component({
  selector: 'ems-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  @Output() languageChange: EventEmitter<Language> = new EventEmitter();

  private selectedLanguage: Language | undefined

  public get Languages(): Array<Language> {
    return Language.List()
  }

  public get SelectedLanguage(): Language | undefined {
    return this.selectedLanguage
  }
  
  public get Language(): Language {
    return TranslationService.CurrentLanguage
  }

  public imageUrl(language: Language): string {
    return `${Environment.FlagPath}${language.FlagCode.toString()}.svg`
  }

  public switchLanguage(code: CountryCode): void {
    const selectedLanguage: Language | undefined = Language.get(code);
    if (!!selectedLanguage) {
      this.translationService.switchLanguage(selectedLanguage)
      this.languageChange.emit(selectedLanguage)
    }
  }

  constructor(private translationService: TranslationService) { }

  ngOnInit(): void {
  }

}
